import { render } from "./auth.vue?vue&type=template&id=3bfa6ba6&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import "./auth.vue?vue&type=style&index=0&id=3bfa6ba6&lang=scss&scoped=true"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfa6ba6"]])

export default __exports__